import type { ActivityModule } from '../../core/activity';
import { mountRomanNumerals } from './ui';
import levelsData from './levels.json';
import './style.css';

export const romanNumerals: ActivityModule = {
  id: 'roman_numerals',
  title: 'Números romanos',
  description: 'Aprenda a ler e escrever números romanos. Converta entre algarismos romanos e arábicos progredindo das unidades até os milhares.',
  ageMin: 8,
  ageMax: 12,
  difficulty: 4,
  iconPath: 'assets/gcompris-AGPL/roman_numerals/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountRomanNumerals,
};
